import OsDetection from './helpers/osDetection.js';
import { defineCustomElements } from "@tbk-dssy/ui-components-core/loader";
import { tbkSetAssetPath } from '@tbk-dssy/ui-components-core';

tbkSetAssetPath('/wp-content/themes/application/dist/static/tb-design-component-assets');

const imported = [];
const loadedBlockScripts = [];

const importer = async (moduleElement, moduleName) => {
  let moduleFile;

  if (typeof imported[moduleName] === 'undefined') {
    switch (moduleName) {
      case 'navbarToggler':
        moduleFile = await import('./modules/navbarToggler.js');
        break;
      case 'infoIconModal':
        moduleFile = await import('./modules/info-icon-modal/info-icon-modal.js');
        break;
      case 'tocUrlFixer':
        moduleFile = await import('./modules/toc-url-fixer/tocUrlFixer.js');
        break;
      case 'mobileSubmenuToggler':
        moduleFile = await import('./modules/mobileSubmenuToggler.js');
        break;
      case 'mobileFootermenuToggler':
        moduleFile = await import('./modules/mobileFootermenuToggler.js');
        break;
      case 'modalHandler':
        moduleFile = await import('./modules/modalHandler.js');
        break;
      case 'fadeOnScroll':
        moduleFile = await import('./modules/fade-on-scroll/fade-on-scroll.js');
        break;
      case 'dynamicAriaLabel':
        moduleFile = await import('./modules/dynamic-aria-label/dynamic-aria-label.js');
        break;
      case 'datalayerevent':
        moduleFile = await import('./modules/datalayer-events/dataLayerEvents.js');
        break;
      case 'triggerOnUrlAnchor':
        moduleFile = await import('./modules/trigger-on-url-anchor/trigger-on-url-anchor.js');
        break;
      case 'scrollToAnchor':
        moduleFile = await import('./modules/scroll-to-anchor/scroll-to-anchor.js');
        break;
      case 'scrollToAnchorTrigger':
        moduleFile = await import('./modules/scroll-to-anchor-trigger/scroll-to-anchor-trigger.js');
        break;
      case 'formHandler':
        moduleFile = await import('./modules/forms/FormHandler.js');
        break;
      case 'loginModal':
        moduleFile = await import('./modules/login-modal/login-modal.js');
        break;
      case 'contactForm':
        moduleFile = await import('./modules/contact-form/contact-form.js');
        break;
      case 'usercentrics-sdk':
        moduleFile = await import('./modules/usercentrics-sdk/usercentrics-sdk.js');
        break;
      case 'contactbarToggle':
        moduleFile = await import('./modules/contactbar-toggle/contactbar-toggle.js');
        break;
      default:
        return;
    }

    imported.push[moduleName];
  }

  const module = await new moduleFile.default(moduleElement);

  if (moduleName === 'scrollToAnchor') {
    await module.scroll(false);
  } else {
    await module.init();
    moduleElement.setAttribute('data-js-module-initialised', 'true');
  }
};

const addModules = () => {
  const moduleElements = document.querySelectorAll('[data-js-module]:not([data-js-module-initialised])');

  if (moduleElements.length > 0) {
    moduleElements.forEach(moduleElement => {
      const moduleNames = moduleElement.dataset.jsModule.split(',');

      moduleNames.forEach(moduleName => {
        importer(moduleElement, moduleName);
      });
    });
  }
};

const addBlockScripts = () => {
  const blockScriptElements = document.querySelectorAll('[data-block-script]:not([data-block-script-loaded])');

  if (blockScriptElements.length > 0) {
    blockScriptElements.forEach(blockScriptElement => {
      const blockScriptUrls = blockScriptElement.dataset.blockScript;
      const splittedBlockScriptUrls = blockScriptUrls.split(',');

      splittedBlockScriptUrls.forEach(blockScriptUrl => {
        if (blockScriptUrl !== '' && loadedBlockScripts.indexOf(blockScriptUrl) === -1) {
          blockScriptElement.setAttribute('data-block-script-loaded', '');
          const blockScriptElementsWithScript = document.querySelectorAll(`[data-block-script="${blockScriptUrl}"]:not([data-block-script-loaded])`);

          if (blockScriptElementsWithScript.length > 0) {
            blockScriptElementsWithScript.forEach(blockScriptElementWithScript => {
              blockScriptElementWithScript.setAttribute('data-block-script-loaded', '');
            });
          }

          loadedBlockScripts.push(blockScriptUrl);

          const scriptTag = document.createElement('script');
          scriptTag.src = blockScriptUrl;
          scriptTag.async = true;
          document.body.appendChild(scriptTag);
        }
      });
    });
  }
};

window.addEventListener('load', () => {
  addModules();

  const locationHash = window.location.hash;

  if (locationHash !== '') {
    importer(locationHash, 'scrollToAnchor');
  }

  const osDetection = new OsDetection();

  if (osDetection.isIOS() && !document.body.classList.contains('ec-ios')) {
    document.body.classList.add('ec-ios');
  } else if (osDetection.isAndroid() && !document.body.classList.contains('ec-android')) {
    document.body.classList.add('ec-android');
  }

  if (document.body.classList.contains('is-in-iframe')) {
    addBlockScripts();
  }

  const navLinkSizes = [];

  const observer = new MutationObserver((entries) => {
    entries.forEach((entry, index) => {
      if (typeof navLinkSizes[index] !== 'undefined') {
        const targetLink = entry.target;
        const targetLinkFontSize = window.getComputedStyle(targetLink).fontSize;
        const targetLinkLineHeight = window.getComputedStyle(targetLink).lineHeight;
        const targetLinkWordSpacing = window.getComputedStyle(targetLink).wordSpacing;
        const targetLinkLetterSpacing = window.getComputedStyle(targetLink).letterSpacing;

        if (navLinkSizes[index].fontSize !== targetLinkFontSize || navLinkSizes[index].lineHeight !== targetLinkLineHeight || navLinkSizes[index].wordSpacing !== targetLinkWordSpacing || navLinkSizes[index].letterSpacing !== targetLinkLetterSpacing) {
          targetLink.style.wordBreak = 'break-word';
        } else {
          targetLink.style.wordBreak = '';
        }
      }
    });
  });

  const navLinks = document.querySelectorAll('header .ec-header-main-nav > ul > li:not(.ec-help-contact-nav):not(.ec-customer-login-container) ul li a');

  navLinks.forEach(navLink => {
    navLinkSizes.push({
      fontSize: window.getComputedStyle(navLink).fontSize,
      lineHeight: window.getComputedStyle(navLink).lineHeight,
      wordSpacing: window.getComputedStyle(navLink).wordSpacing,
      letterSpacing: window.getComputedStyle(navLink).letterSpacing
    });

    observer.observe(navLink, { attributes: true, attributeFilter: ['style'] });
  });

  defineCustomElements(window);
});

window.addEventListener('reinit-modules', () => {
  addModules();
});

window.addEventListener('load-block-scripts', () => {
  addBlockScripts();
});
